import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'code',
    label: i18n('entities.eventTimeZone.fields.code'),
    schema: schemas.string(
      i18n('entities.eventTimeZone.fields.code'),
      {
        "required": true,
        "max": 128
      },
    ),
  },
];